export const ownerAgentChatHandler = {
    pathPattern: '/brands/:brandId/home',
    scopedToLocation: false,
    toWeb: ({ brandId, chatId }) => ({
        path: `/brands/${brandId}/home`,
        query: { ownerAgentChatId: chatId },
    }),
    toNative: ({ brandId, chatId }) => `/brands/${brandId}/home?${new URLSearchParams({ ownerAgentChatId: chatId })}`,
    resolve: ({ brandId }, query) => {
        const chatId = query.get('ownerAgentChatId');
        if (!chatId?.trim())
            return null;
        return { key: 'owner-agent-chat', params: { brandId, chatId } };
    },
    meta: {
        title: 'Owner Agent conversation',
        description: 'Opens the global Owner Agent widget on an existing chat in Hestia.',
        status: 'live',
        platforms: { web: true, ios: true, android: true },
        flag: 'hestia.ownerAgentWidget',
        tracked: true,
        trackingKey: 'chatId',
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'ownerAgentChatId', in: 'query', required: true },
        ],
        example: {
            params: { brandId: 'exampleBrandId', chatId: 'exampleChatId' },
        },
    },
};
//# sourceMappingURL=owner-agent-chat.js.map